import { Box } from "@mui/material";
import React, { useMemo } from "react";

const InsetCard = ({ children, grey = false, sx }) => {
  const styles = useMemo(() => {
    return {
      py: 4,
      px: 3,
      borderRadius: 2,
      border: `1px solid #e5e7eb`,
      overflow: "hidden",
      ...sx,
    };
  }, [sx]);

  if (grey) {
    return <GreyCard sx={styles}>{children}</GreyCard>;
  }
  return <Box sx={styles}>{children}</Box>;
};

const GreyCard = ({ children, sx }) => {
  return (
    <Box
      sx={{
        overflow: "hidden",
        border: `1px solid #e5e7eb`,
        background: "#f9fafb",
        borderRadius: 2,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
export default InsetCard;
